// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swing-button[data-v-229d9fef] {\n  font-size: 20px;\n  color: black;\n  background-color: white;\n  position: absolute;\n  left: 50%;\n  border-radius: 50%;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
